/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

export enum FrontTypeEnum {
	SBP = "SBP",
	TERMINAL_BASE = "TERMINAL_BASE",
	CASH = "CASH",
	YANDEX_BADGE = "YANDEX_BADGE",
	PAYMENT_TRACKER = "PAYMENT_TRACKER",
}
